export default "__VITE_ASSET__CqJrIsFf__"